import classNames from 'classnames';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import {defineMessages, injectIntl} from 'react-intl';

import BufferedInputHOC from '../forms/buffered-input-hoc.jsx';
import Input from '../forms/input.jsx';
const BufferedInput = BufferedInputHOC(Input);

import './project-title-input.css';
import { useSelector, useDispatch } from 'react-redux'
import { setProjectTitle, setProjectTitleold } from '../store/project-state' 

const messages = defineMessages({
    projectTitlePlaceholder: {
        id: 'gui.gui.projectTitlePlaceholder',
        description: 'Placeholder for project title when blank',
        defaultMessage: 'Project title here'
    }
});

const ProjectTitleInput = ({
    className
}) => {
    const title = useSelector((state: RootState) => state.projectStore.title)
    
    const dispatch = useDispatch()
    const onSubmit = (ti) => {
        dispatch(setProjectTitle(ti))
    }
    return <BufferedInput
        className={`titleField ${className}`}
        maxLength="100"
        placeholder="在此填写作品标题"
        // placeholder={intl.formatMessage(messages.projectTitlePlaceholder)}
        value={title}
        tabIndex="0"
        type="text"
        // disabled="true"
        onSubmit={onSubmit}
    />
};

export default ProjectTitleInput;
